// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4303":"a1aa9fba","4445":"5002cace"}[chunkId] + ".chunk.css";
};